import { assertDefined } from './debug';

export interface Serializable {
  __className(): string;
}

interface RegisteredType<T extends Serializable> {
  replacer: (value: T) => any;
  reviver: (value: any) => T;
}

const registeredTypes: Map<string, RegisteredType<any>> = new Map();

export function registerType<T extends Serializable>(name: string, t: RegisteredType<T>) {
  registeredTypes.set(name, t);
}

function replacer(_key: string, value: any) {
  if (typeof value?.__className !== 'function') return value;
  const className: string = value.__className();
  const registeredType = registeredTypes.get(className);
  assertDefined(registeredType, `Unknown types ${className}`);
  const result = registeredType.replacer(value);
  result.__className = value.__className();
  return result;
}

export function serializeMessage(message: any): string {
  return JSON.stringify(message, replacer);
}

function reviver<T>(_key: string, value: any): T {
  if (typeof value?.__className !== 'string') return value;
  const registeredType = registeredTypes.get(value.__className);
  assertDefined(registeredType, `Unknown types ${value.__className}`);
  return registeredType.reviver(value);
}

export function unserializeMessage<T>(message: any): any {
  return JSON.parse(message, reviver<T>);
}

export function sendSerializedMessage(context: typeof globalThis | Worker, message: any) {
  context.postMessage(serializeMessage(message));
}

export function receiveSerializedMessages<T>(context: typeof globalThis | Worker, callback: (message: T) => void) {
  context.onmessage = event => {
    const message = unserializeMessage<T>(event.data);
    callback(message);
  };
}
